// tslint:disable

import axios, { AxiosResponse } from 'axios';
import 'jquery';
import { clone, get } from 'lodash';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { ContentBuilderField } from '../../components/fields/contentBuilder.field';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { MediaItemField } from '../../components/fields/media-item.field';
import { SeoMetadataField } from '../../components/fields/seoMetadata.field';
import { TextAreaField } from '../../components/fields/textarea.field';
import { TimestampBlameable } from '../../components/fields/TimestampBlameable';
import { Field, FormLib } from '../../components/libs/form.lib';
import { MetadataReaderLib } from '../../components/libs/metadata-reader.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import {
    ListActions,
    ListResponsePresenterTable
} from '../../components/structurals/presenters/list-response-presenter-table';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import { Environment } from '../../environment/environment';
import { Notification } from '../../index';


export class DefaultArticle extends React.Component<any, any> {
    public meta = new MetadataReaderLib(null);
    public state: any = {
        showSlug: false,
        albums: []
    };

    public async handleFormArrive() {
        try {
            const response: AxiosResponse = await axios.get(`${Environment.get('api.base')}/media-album`, {
                withCredentials: true,
                params: {
                    article: this.props.ENTITY_ID
                }
            });

            if (!response.data || !response.data['hydra:member']) {
                throw new Error('Faszom');
            }

            if (response.data['hydra:member'] && response.data['hydra:member'][0]) {
                const albums = get(response.data, '[hydra:member]', []);
                this.setState({
                    albums: albums.map((i: any) => this.toIri(i))
                });

            } else {
                this.setState({albums: []});
            }

        } catch (err) {
            console.warn(err.message);
        }

        // const albumField: Field = form.fields.albums;
        //
        // albumField.registerField();
        // albumField.onValueChanges$.subscribe((v: any) => {
        //     this.setState({
        //         albums: v.map((i: any) => this.toIri(i))
        //     });
        // });
    }

    public handleAlbumCreated(form: FormLib, album: any) {
        const albumField: Field = form.fields.albums;
        const albums = clone(albumField.value);
        const newAlbumIri = this.toIri(album);
        albums.push(newAlbumIri);
        albumField.setValue(albums.map((i: any) => this.toIri(i)));

        this.setState({
            albums: albums || []
        });
    }

    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    componentWillMount() {
        this.handleFormArrive();
    }

    render() {
        return (
            <ResourceLoader entity="article" entityId={this.props.ENTITY_ID} render={(form: FormLib, raw: any) => <div>
                {/*{this.handleFormArrive(form)}*/}
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create a new article' : `Edit Article - ${form.fields.title.value}`}
                    </h2>
                    <br/>
                    {form.fields.slug.value &&
                    <div>
                        {!this.state.showSlug &&
                        <div>
                            <a href={this.meta.getLink('article', raw).indexOf('touringandadventure') > 0 ? `http://www.touringandadventure.com/news/${form.fields.slug.value}` : `https://aspiretravelclub.co.uk/news/${form.fields.slug.value}`}
                               target="_blank">{this.meta.getLink('article', raw).indexOf('touringandadventure') > 0 ? `http://www.touringandadventure.com/news/${form.fields.slug.value}` : `https://aspiretravelclub.co.uk/news/${form.fields.slug.value}`}</a>
                            &nbsp;
                            <button className="btn btn-xs btn-warning" onClick={() => this.toggleSlug()}
                                    title="Edit slug"><i className="fa fa-fw fa-pencil"></i></button>
                        </div>
                        }
                        {this.state.showSlug &&
                        <InputField
                            inputSize="sm"
                            field={form.fields.slug}
                            validators={[Validators.required('Required')]}/>
                        }
                    </div>
                    }

                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-9">
                        <ToggleBoxComponent title="Article details" color="green" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">

                                    <InputField
                                        field={form.fields.title}
                                        validators={[Validators.required('Required')]}/>

                                    <InputField
                                        field={form.fields.slug}
                                        validators={[Validators.required('Required')]}/>

                                    <TextAreaField
                                        field={form.fields.lead}
                                        validators={[Validators.required('Required')]}/>

                                    <TextAreaField
                                        field={form.fields.headerLead}
                                    />

                                    <ContentBuilderField
                                        field={form.fields.content}
                                        height={800}
                                        // validators={[Validators.wysiwygRequired('required')]}
                                    />
                                </div>
                            </div>

                        </ToggleBoxComponent>
                        <ToggleBoxComponent title='Albums' alwaysOpen={true} preIcon="fa-image">


                            <IriField
                                field={form.fields.albums}
                                defaultAll={false}
                                itemRender={(item: any) => get(item, 'title')}
                                onChange={(event: any) => this.setState({albums: event})}
                            />


                            <ListResponsePresenterTable
                                tableId="albums"
                                items={this.state.albums || []}
                                head={() => <tr>
                                    <th>Name</th>
                                    <th style={{width: '1%'}}/>
                                </tr>}
                                row={(item: any, index: number, actions: ListActions) => item && item.replace &&
                                    <tr key={index} data-album={item}>
                                        <td>
                                            <IriPresenter iri={item} path={'title'}/>
                                        </td>
                                        <td>
                                            <div className="btn-group btn-group-sm resource-modal-fixup">
                                                <ResourceModal
                                                    entity='media-album'
                                                    entityId={item && item.replace('/media-album/', '')}
                                                    title={'Edit Album'}
                                                />
                                                <button type="button" className="btn btn-primary dropdown-toggle"
                                                        data-toggle="dropdown">
                                                    <span className="sr-only">Toggle Dropdown</span>
                                                </button>
                                                <ul className="dropdown-menu" role="menu">
                                                    <li>
                                                        <a onClick={(event: any) => this.handleDelete(item, actions, form)}>Delete
                                                            Album</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>}
                            />

                            <ResourceModal
                                entity={'media-album'}
                                entityId={'create'}
                                title={'Add new album'}
                                config={{'article': `/article/${this.props.ENTITY_ID}`}}
                                onCreateSuccessful={(event: any) => this.handleAlbumCreated(form, event)}
                                dontClose={true}
                            />

                        </ToggleBoxComponent>
                        <SeoMetadataField
                            field={form.fields.seoMetadata}
                        />
                    </div>
                    <div className="col-xs-12 col-md-3">

                        <ToggleBoxComponent title="Images" color="blue" alwaysOpen={true} preIcon={'fa-image'}>
                            <MediaItemField
                                field={form.fields.cover}
                            />
                            <MediaItemField
                                field={form.fields.promoCover}
                            />
                        </ToggleBoxComponent>
                        <ToggleBoxComponent title="Properties" color="red" alwaysOpen={true} preIcon={'fa-cogs'}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <CheckboxField
                                        field={form.fields.featured}
                                    />

                                    <IriField
                                        field={form.fields.category}
                                        defaultAll={false}
                                        itemRender={(item: any) => get(item, 'title')}
                                        validators={[Validators.required('Required')]}/>

                                    <IriField
                                        field={form.fields.destination}
                                        defaultAll={false}
                                        itemRender={(item: any) => get(item, 'title')}
                                    />

                                    <IriField
                                        field={form.fields.tag}
                                        defaultAll={false}
                                        itemRender={(item: any) => get(item, 'title')}
                                    />
                                    <ResourceModal entity={'article-tag'} entityId={'create'} extClass={'btn-xs'}
                                                   title={<div><i className="fa fa-plus"/> Add new Tag</div>}/>

                                    <div className="divider" />

                                    <TimestampBlameable form={form}/>
                                </div>
                            </div>

                        </ToggleBoxComponent>

                    </div>
                </div>
                <div className="col-xs-12">
                    <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                </div>

            </div>}/>
        );
    }

    private toggleSlug() {
        this.setState({showSlug: !this.state.showSlug});
    }

    private toIri(raw: any) {
        if (get(raw, '@id')) {
            return get(raw, '@id');
        } else {
            return raw;
        }
    }

    private async handleDelete(item: any, ListActions: ListActions, form: any) {

        const answer = await Notification.delete();

        if (answer === true) {
            try {
                //await ListActions.delete(item);

                let index = this.state.albums.indexOf(item);

                if (this.state.albums.indexOf(item) > -1) {
                    let items: any = this.state.albums;

                    items.splice(index, 1);

                    this.setState({
                        albums: items
                    });
                }

                axios.put(`${Environment.get('api.base')}/article/${this.props.ENTITY_ID}`, {
                    albums: this.state.albums
                }, {
                    withCredentials: true
                });


                form.fields.albums.setValue(this.state.albums);


            } catch (error) {
                Notification.error('Error', error.message);
                false;
            } finally {
                // list.refetch();
            }
        }
    }
}

/**
 <SectionHeaderComponent title={`${form.fields.title.value || 'CREATE ARTICLE'}`} subtitle={form.fields.slug.value}/>
 */

/**

 <ArrayField
 title={'Tags Mixed'}
 itemConfig={{
                                            title: 'Izé',
                                            iri: 'article-tag'
                                        }}
 item={(schemaField: Field) => <IriField
                                            field={schemaField}
                                            defaultAll={false}
                                            itemRender={(item: any) => get(item, 'title')}
                                        />}
 field={form.fields.tag}
 />

 */



// WEBPACK FOOTER //
// ./src/__templates/details/default.article.tsx